import http from '../httpService';

const ProsecutorOfficeService = {
  getOfficesService: name => http.get(`prosecutor-offices?name=${name}`),

  getProsecutorOfficesService: params => http.get('prosecutor-offices', { params }),
};

export default ProsecutorOfficeService;
